import React, {Component} from 'react';
import yes_btn from './yes_btn.png';
import no_btn from './no_btn.png';
import { connect } from 'react-redux';
import * as actions from '../../constants/actions';
import './IdentityConfirmation.css';
import URLS from '../../constants/urls';
import { getEnvironmentFromUrl } from '../../services/network';
import decode from 'jwt-decode';
import { signout } from '../../services/oidc';

const mapStateToProps = state => ({
    tokenData: state.app.tokenData,
    idTokenData: state.app.idTokenData,
    studentName: state.app.studentName,
    studentSiteCode: state.app.studentSiteCode
});

const mapDispatchToProps = dispatch => ({
    onIdentityConfirmation: () => dispatch({ type: actions.APP_IDENTITY_CONFIRMED}),
    onIdentityDenied: () => dispatch({type: actions.APP_IDENTITY_DENIED}),
    onStudentName: (studentName) => dispatch({type: actions.APP_STUDENT_NAME, payload: studentName}),
    onStudentSiteCode: (siteCode) => dispatch({type: actions.APP_STUDENT_SITECODE, payload: siteCode}),
    clearPreviouslyStoredQueryParameters: () => dispatch({type: actions.APP_CLEAR_STORED_QUERY_PARAMS})
});

export class IdentityConfirmation extends Component
{
    constructor(props){
        super(props);
        var token = this.props.tokenData;
        if (token != null){
            var decodedString = decode(token);
            this.props.onStudentName(decodedString['given_name']);
            let sitecodes = decodedString['http://il/sites'];
            this.props.onStudentSiteCode(sitecodes.split(',')[0]);
        }else{
            this.props.onStudentName("Student Data Not Found");
        }

        this.handleIdentityDenied = this.handleIdentityDenied.bind(this);
    }

    handleIdentityDenied(imlp) {
        let environment = getEnvironmentFromUrl(window.location.toString(), window.location.search);
        this.props.clearPreviouslyStoredQueryParameters(); // We should assume previous query parameters were incorrect.

        if (!imlp)
        {
            let signoutUrl = "";
            if(this.props.idTokenData !== null){
                const auth =  URLS[environment].auth;
                const signinUrl = URLS[environment].signin;
                signoutUrl = auth + "/connect/endsession?id_token_hint=" + this.props.idTokenData + "&post_logout_redirect_uri=" + signinUrl;
            } else {
                signoutUrl = URLS[environment].signoutPage;
            }

            console.log(signoutUrl);
            window.location.replace(signoutUrl);
        }else{
            this.props.onIdentityDenied();
            signout().catch((error) => console.error(error));
        }
    }

    componentDidMount() {
        window.document.title = 'Confirming User | Imagine Learning';
        // Set focus to the first button for keyboard navigation
        const yesButton = document.getElementById('identity-confirm-yes');
        if (yesButton) {
            yesButton.focus();
        }
    }

    render ()
    {
        return (
            <div 
                className="confirm-background"
                role="dialog"
                aria-labelledby="identity-confirmation-title"
                aria-describedby="identity-confirmation-question"
            >
                <h3 
                    id="identity-confirmation-title" 
                    className="text-title"
                    aria-live="polite"
                >
                    <span id="identity-confirmation-question">
                        Is your name <span className="text-user">{this.props.studentName}</span>?
                    </span>
                </h3>
                <div className="bottom" role="group" aria-label="Confirmation buttons">
                    <button
                        id="identity-confirm-yes"
                        className="image-background button-yes"
                        onClick={() => this.props.onIdentityConfirmation()}
                        aria-label={`Yes, my name is ${this.props.studentName}`}
                        type="button"
                    >
                        <img className="image-link" alt="" src={yes_btn} aria-hidden="true" />
                    </button>
                    <button
                        id="identity-confirm-no"
                        className="image-background button-no"
                        onClick={() => this.handleIdentityDenied(this.props.imlp)}
                        aria-label={`No, my name is not ${this.props.studentName}`}
                        type="button"
                    >
                        <img className="image-link" alt="" src={no_btn} aria-hidden="true" />
                    </button>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IdentityConfirmation);


// WEBPACK FOOTER //
// ./src/components/IdentityConfirmation/IdentityConfirmation.js